<template>
  <div>
      <div :style="{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'space-between'
      }">

        <div :style="{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          textAlign: 'left'
        }">

            <div style="margin-top: 10px;">
                <span type="label">Inventory Type</span>
                <br><br>
                <el-radio @change="loadItemCategories(1)" :label="1" v-model="$store.state.inventoryMaster.props.item_type">Fabric</el-radio>
                <el-radio @change="loadItemCategories(2)" :label="2" v-model="$store.state.inventoryMaster.props.item_type">Ready Item</el-radio>
                <el-radio @change="loadItemCategories(3)" :label="3" v-model="$store.state.inventoryMaster.props.item_type">Stitching Material</el-radio>
                <el-radio @change="loadItemCategories(4)" :label="4" v-model="$store.state.inventoryMaster.props.item_type">Equipments</el-radio>
            </div>
            <div style="margin-top: 20px;">
                <el-checkbox :disabled="$store.state.inventoryMaster.props.item_type > 2" v-model="$store.state.inventoryMaster.props.fabric_cut_length">Cut-Length {{$store.state.inventoryMaster.props.item_type == 1 ? 'Fabric' : 'Item'}}</el-checkbox>
                <el-checkbox :disabled="$store.state.inventoryMaster.props.item_type !== 1" v-model="$store.state.inventoryMaster.props.fabric_can_be_sold_as_retail">Can Be Sold As Retail?</el-checkbox>
            </div>
            <div style="margin-top: 20px;">
                <el-checkbox :disabled="$store.state.inventoryMaster.props.item_type !== 2" v-model="$store.state.inventoryMaster.props.most_popular">Most Popular Item</el-checkbox>
            </div>
            <div style="margin-top: 20px;">
                <span type="label">SKU#</span>
                <br>
                <el-input @focus="$event.target.select()"
                    id="sku_code"
                    size="small"
                    placeholder="Leave it blank if not sure"
                    v-model.trim="$store.state.inventoryMaster.props.sku_code"
                    style="width: 400px;">                    
                </el-input>
            </div>
           <!-- <div style="margin-top: 20px;" v-if="$store.state.inventoryMaster.props.id === 0">
                <span type="label">Number Of Variants</span>
                <br>
                <el-input @focus="$event.target.select()"
                    size="small"
                    type="number"
                    min="0"
                    v-model.trim="$store.state.inventoryMaster.props.copies"
                    style="width: 400px;">                    
                </el-input>
            </div>-->
            <div style="margin-top: 20px;" v-if="$store.state.inventoryMaster.props.item_type === 2">
                <el-checkbox v-model="$store.state.inventoryMaster.props.alteration_allowed">Alteration Allowed?</el-checkbox>
            </div>  
            <div style="margin-top: 20px;" v-if="$store.state.inventoryMaster.props.alteration_allowed">
                <span class="label">Alteration Tailoring Template</span>
                <br>
                <el-select 
                    v-model="$store.state.inventoryMaster.props.alteration_tailoring_item_id" 
                    filterable 
                    remote
                    :remote-method="searchSKUCode"
                    placeholder="Select" 
                    style="width: 400px;">
                    <el-option
                    v-for="item in $store.getters.getItemAutocompleteList.filter((option) => {
                        return !option.is_combination_item
                    })"
                    :key="item.id"
                    :label="item.template_name"
                    :value="item.id">
                    <span style="float: left" v-html="item.template_name"></span>
                    </el-option>
                </el-select>
            </div>          
            <div style="margin-top: 20px;">
                <span type="label">Category</span>
                <br>
                
                <el-select 
                    id="sub_category_id"
                    size="small"
                    v-model="$store.state.inventoryMaster.props.sub_category_id" 
                    filterable style="width: 400px; text-align: left;">
                    <el-option-group
                    v-for="dataGroup in $store.getters.getItemCategoryList"
                    :key="dataGroup.id">
                    <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                        <span style="float: left; padding-left: 5px;" v-html="dataGroup.category_name"></span>
                        <el-option
                            v-for="item in dataGroup.sub_category_list"
                            :key="item.id"
                            :label="item.sub_category_name"
                            :value="item.id">
                            <span style="float: left" v-html="item.sub_category_name"></span>
                        </el-option>
                    </div>
                    
                    </el-option-group>
                </el-select>
            </div>

            <div style="margin-top: 20px;">
                <span type="label">Collection</span>
                <br>
                <el-select size="small"
                    v-model="$store.state.inventoryMaster.props.collection_id" filterable style="width: 400px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getTailoringCollectionList"
                        :key="index"
                        :label="data.collection_name"
                        :value="data.id">
                        <span style="float: left;">{{ data.collection_name }}</span>
                    </el-option>
                </el-select>
            </div>

            <div style="margin-top: 10px;" v-if="$store.state.inventoryMaster.props.item_type < 3 && $store.getters.getHandloomClusterList.length>0">
                <span type="label">Handloom Cluster</span>
                <br>
                
                <el-select 
                size="small"
                v-model="$store.state.inventoryMaster.props.cluster_id" 
                filterable style="width: 400px; text-align: left;">
                <el-option
                    v-for="(data, index) in $store.getters.getHandloomClusterList"
                    :key="index"
                    :label="data.cluster_name"
                    :value="data.id">
                    <span style="float: left" v-html="data.cluster_name"></span>
                </el-option>
                </el-select>
            </div>
            
            <div style="margin-top: 10px;" v-if="getItemType === 1">
                <span type="label">Fabric Width</span>
                <br>
                <el-select 
                    size="small"
                    v-model="$store.state.inventoryMaster.props.fabric_width_id" 
                    filterable 
                    style="width: 400px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getFabricWidthList"
                        :key="index"
                        :label="data.width_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.width_name"></span>
                    </el-option>
                </el-select>
            </div>
            <div style="margin-top: 10px;" v-if="getItemType === 1">
                <span type="label">Width Based Flat Consumption</span>
                <br>
                <el-input @focus="$event.target.select()"
                    size="small"
                    type="number"
                    v-model="$store.state.inventoryMaster.props.default_tailoring_consumption"
                    style="width: 400px;">
                </el-input>
            </div>
            
            <div style="margin-top: 10px;" v-if="getItemType === 1">
                <span type="label">Fabric Weight</span>
                <br>
                <el-select 
                    size="small"
                    v-model="$store.state.inventoryMaster.props.fabric_gsm_id" 
                    filterable 
                    style="width: 400px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getFabricGSMMasterList"
                        :key="index"
                        :label="data.weight_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.weight_name"></span>
                    </el-option>
                </el-select>
            </div>
            <div style="margin-top: 10px;">
                <span type="label">Article Name</span>
                <br>
                <el-input @focus="$event.target.select()"
                    size="small"
                    v-model="$store.state.inventoryMaster.props.article_name"
                    style="width: 400px;">
                </el-input>
            </div>
            
            <div style="margin-top: 10px;" v-if="getItemType <4">
                <span type="label">Composition</span>
                <br>
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.composition"
                    size="small"
                    style="width: 400px;">
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <span type="label">{{getItemType < 4 ? 'Design ' : ''}}Description</span>
                <br>
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.design_description"
                    size="small"
                    style="width: 400px;">
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <span type="label">Unit Of Measurement</span>
                <br>
                <el-select 
                    size="small"
                    v-model="$store.state.inventoryMaster.props.unit_of_measurement_id" 
                    filterable 
                    style="width: 400px; text-align: left;">
                    <el-option
                        v-for="(data, index) in getUOMList"
                        :key="index"
                        :label="data.unit_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.unit_name"></span>
                    </el-option>
                </el-select>
            </div>
        
            <div style="margin-top: 10px;">
                <span type="label">Re-Order Level</span>
                <br>
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.reorder_level"
                    type="number"
                    size="small"
                    style="width: 400px;">
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <span type="label">Style Number</span>
                <br>
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.style_number"
                    size="small"
                    style="width: 400px;">
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <span type="label">Brand Number</span>
                <br>
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.brand_name"
                    size="small"
                    style="width: 400px;">
                </el-input>
            </div>
            <div style="margin-top: 10px;" v-if="getItemType <4">
                <span type="label">Trade Number/Supplier Ref.</span>
                <br>
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.trade_name"
                    size="small"
                    style="width: 400px;">
                </el-input>
            </div>
            <div style="margin-top: 10px;" v-if="getItemType <4">
                <span type="label">Shade</span>
                <br>
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.shade_number"
                    size="small"
                    style="width: 400px;">
                </el-input>
            </div>

            <div style="margin-top: 10px;" v-if="getItemType <4">
                <span type="label">Rack/Shelf Number</span>
                <br>
                <el-select 
                    size="small"
                    v-model="$store.state.inventoryMaster.props.rack_id" 
                    filterable 
                    multiple
                    style="width: 400px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getInventoryRackList"
                        :key="index"
                        :label="data.rack_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.rack_name"></span>
                    </el-option>
                </el-select>
            </div>

            <div style="margin-top: 10px;">
                    <span type="label">From Vendor</span>
                    <br>
                    <!--.filter(t => t.trackable_item_vendor)-->
                    <el-select 
                        id="vendor_id"
                        size="small"
                        v-model="$store.state.inventoryMaster.props.vendor_id" 
                        filterable 
                        style="width: 400px; text-align: left;">
                        <el-option
                            v-for="(data, index) in $store.getters.getVendorMasterList"
                            :key="index"
                            :label="data.vendor_name"
                            :value="data.id">
                            <span style="float: left" v-html="data.vendor_name"></span>
                            <span style="float: right" v-html="data.brand_name"></span>
                        </el-option>
                    </el-select>
            </div>

            <!--<div style="margin-top: 10px;" v-if="getItemType > 1">
                <span type="label">Dimensions (L x W x H)</span>
                <br>

                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.length"
                    size="small"

                    style="width: 125px;">
                </el-input>
                x
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.width"
                    size="small"
                    style="width: 125px;">
                </el-input>
                x
                <el-input @focus="$event.target.select()"
                    v-model="$store.state.inventoryMaster.props.height"
                    size="small"
                    style="width: 125px;">
                </el-input>
            </div>-->

            <div style="margin-top: 20px;">
                <span class="label">Available In Which Location?</span>
                <br>
                <el-select 
                    v-model="$store.state.inventoryMaster.props.store_id" 
                    filterable 
                    placeholder="Select" 
                    style="width: 400px;">
                    <el-option 
                        :label="'All Locations'"
                        :value="0">
                        <span style="float: left" v-html="'All Locations'"></span>
                    </el-option>
                    <el-option
                    v-for="item in $store.getters.getAccessibleStoreList.filter(t => t.retail)"
                    :key="item.id"
                    :label="item.store_name"
                    :value="item.id">
                    <span style="float: left" v-html="item.store_name"></span>
                    </el-option>
                </el-select>
            </div>

            <div style="margin-top: 10px;" v-if="getItemType === 4">
                <span type="label">Issued To</span>
                <br>
                <el-select 
                    :id="'staff_name'"
                    size="small"
                    v-model="$store.state.inventoryMaster.props.issued_to" 
                    filterable 
                    style="width: 400px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active)"
                        :key="index"
                        :label="data.staff_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.staff_name"></span>
                    </el-option>
                </el-select> 
            </div>
            <div style="margin-top: 10px;" v-if="getItemType === 4">
                <span type="label">Caretaker</span>
                <br>
                <el-select 
                    :id="'staff_name'"
                    size="small"
                    v-model="$store.state.inventoryMaster.props.caretaker_id" 
                    filterable 
                    style="width: 400px; text-align: left;">
                    <el-option
                        v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active && t.staff_type === 0)"
                        :key="index"
                        :label="data.staff_name"
                        :value="data.id">
                        <span style="float: left" v-html="data.staff_name"></span>
                    </el-option>
                </el-select> 
            </div>
            <div style="margin-top: 10px;" v-if="getItemType === 4">
                <span type="label">Purchase Date</span>
                <br>
                <el-date-picker
                    size="small"
                    v-model="$store.state.inventoryMaster.props.purchase_date"
                    type="date"
                    style="width: 400px;" 
                    value-format="yyyy-MM-dd"
                    format="MMM dd yyyy">
                </el-date-picker>
                
            </div>
            <div style="margin-top: 10px;" v-if="getItemType === 4">
                <span type="label">Warranty Expiry Date</span>
                <br>
                <el-date-picker
                    size="small"
                    v-model="$store.state.inventoryMaster.props.warranty_expiry_date"
                    type="date"
                    style="width: 400px;" 
                    value-format="yyyy-MM-dd"
                    format="MMM dd yyyy">
                </el-date-picker>
                
            </div>
        </div>
        

        <div>
             <UploadFile 
                @uploaded="$store.state.inventoryMaster.props.profile_photo=$event"
                :image_path="$store.state.inventoryMaster.props.profile_photo"
                :image_width="150"
                :file_dialog_id="'inventoryMaster_photo_file_upload'"
                :button_style="'width: 100px; top: 5px; position: relative;'"
            />


        </div>    
      </div>
  </div>
</template>

<script>
export default {
    computed: {
        getItemType() {
            return this.$store.state.inventoryMaster.props.item_type
        },
        getUOMList() {
            let uomList = this.$store.getters.getUOMMasterList
            return uomList
            /*let returnList = []

            if(this.getItemType === 1) {
                returnList = uomList.filter((option) => {
                    return option.for_fabric === 1
                })
            } else {
                returnList = uomList
            }
            return returnList*/
        }
    },
    methods: {
        loadItemCategories(type) {
            this.$store.state.inventoryMaster.props.most_popular = false
            this.$store.dispatch('fetchItemSubCategoryList', {type: type})
        },
        searchSKUCode(query) {
            this.$store.dispatch('fetchTailoringMasterAutocompleteList', 
            {
                query: query, 
                sales_form_request: true,
                inventoryPayload: {
                query: query, 
                store_id: 0,
                sales_form_request: true,
                search_fabric_only: false,
                search_column: ['sku_code', 'article_name']
                }
            })        
        }
    },
    mounted() {
        setTimeout(() => {
            this.loadItemCategories(this.$store.state.inventoryMaster.props.item_type)
        }, 400);
    }
}
</script>

<style scoped>

    
</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/Basic.vue